import { useEffect, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export const ConfigurationPage = ({ refFrom, onSubmitForm, defaultValues }) => {

    const { t } = useTranslation();
    const { register, handleSubmit } = useForm(defaultValues);

    useImperativeHandle(refFrom, () => ({
        submitForm() {
            handleSubmit(onSubmitForm)();
        }
    }));

    return (
        <div className="component-collapse-configuraciones">

            <div className="collapse-wrapper">
                <div className="collapse-item show" tabIndex="0">
                    <a href="#item" className="collapse-item-heading" tabIndex="0" role="button">
                        {t('validator.option-configuration')}
                    </a>
                    {/* collapse content */}
                    <div id="item" className="collapse-item-content">
                        <form onSubmit={handleSubmit(onSubmitForm)}>

                            {/* Item 1 */}
                            <div className="form-detail-item">
                                <span className="detail-title"> {t('validator.level-title')} </span>
                                <div className="inline-group">
                                    <div className="form-group">
                                        <input {...register('extended_report')} className="form-checkbox" id="extended_report1" type="radio" value="true" />
                                        <label className="form-label" htmlFor="extended_report1"> Completo </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('extended_report')} className="form-checkbox" id="extended_report2" type="radio" value="false" />
                                        <label className="form-label" htmlFor="extended_report2"> Simple </label>
                                    </div>
                                </div>
                                <p className="txt-detail"> {t('validator.level-detail')} </p>
                            </div>

                            {/* Item 2 */}
                            <div className="form-detail-item">
                                <span className="detail-title"> {t('validator.type-title')} </span>
                                <div className="inline-group">
                                    <div className="form-group">
                                        <input {...register('report_type')} className="form-checkbox" id="report_type1" type="radio" value="html" />
                                        <label className="form-label" htmlFor="report_type1"> HTML </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('report_type')} className="form-checkbox" id="report_type2" type="radio" value="pdf" />
                                        <label className="form-label" htmlFor="report_type2"> PDF </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('report_type')} className="form-checkbox" id="report_type3" type="radio" value="json" />
                                        <label className="form-label" htmlFor="report_type3"> JSON </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('report_type')} className="form-checkbox" id="report_type4" type="radio" value="xml" />
                                        <label className="form-label" htmlFor="report_type4"> XML </label>
                                    </div>
                                </div>
                                <p className="txt-detail"> {t('validator.type-detail')} </p>
                            </div>

                            {/* Item 3 */}
                            <div className="form-detail-item">
                                <span className="detail-title"> {t('validator.checks-title')} </span>
                                <div className="inline-group">
                                    <div className="form-group">
                                        <input {...register('verify_incremental_updates')} className="form-checkbox" id="verify_incremental_updates1" type="radio" value="true" />
                                        <label className="form-label" htmlFor="verify_incremental_updates1"> Si </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('verify_incremental_updates')} className="form-checkbox" id="verify_incremental_updates2" type="radio" value="false" />
                                        <label className="form-label" htmlFor="verify_incremental_updates2"> No </label>
                                    </div>
                                </div>
                                <p className="txt-detail"> {t('validator.checks-detail')} </p>
                            </div>

                            {/* Item 4 */}
                            <div className="form-detail-item">
                                <span className="detail-title"> {t('validator.introduce-title')} </span>
                                <div className="inline-group">
                                    <div className="form-group">
                                        <input {...register('show_payload_json')} className="form-checkbox" id="show_payload_json1" type="radio" value="true" />
                                        <label className="form-label" htmlFor="show_payload_json1"> Si </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('show_payload_json')} className="form-checkbox" id="show_payload_json2" type="radio" value="false" />
                                        <label className="form-label" htmlFor="show_payload_json2"> No </label>
                                    </div>
                                </div>
                                <p className="txt-detail"> {t('validator.introduce-detail')} </p>
                            </div>

                            {/* Item 5
                            <div className="form-detail-item">
                                <span className="detail-title"> {t('validator.issue-title')} </span>
                                <div className="inline-group">
                                    <div className="form-group">
                                        <input {...register('emit_receipt')} className="form-checkbox" id="emit_receipt1" type="radio" value="true" />
                                        <label className="form-label" htmlFor="emit_receipt1"> Si </label>
                                    </div>
                                    <div className="form-group">
                                        <input {...register('emit_receipt')} className="form-checkbox" id="emit_receipt2" type="radio" value="false" />
                                        <label className="form-label" htmlFor="emit_receipt2"> No </label>
                                    </div>
                                </div>
                                <p className="txt-detail">
                                    {t('validator.issue-detail-1')}
                                    <NavLink to="https://datatracker.ietf.org/doc/html/rfc2634">RFC 2634</NavLink>
                                    {t('validator.issue-detail-2')}
                                </p>
                            </div>*/}

                        </form>
                    </div>
                </div>
            </div>

        </div>
    )
}